import {Injectable} from '@angular/core';

@Injectable()
export class RoleService {

  readonly roles: {
    id: string,
    description: string
    sfGuardGroupId: number,
    sfGuardGroupName: string,
    sfGuardGroupDescription: string,
  }[];

  constructor() {
    // Do not modify order
    this.roles = [
      {
        id: 'Super',
        description: 'Has all rights.',
        sfGuardGroupId: 1,
        sfGuardGroupName: 'super',
        sfGuardGroupDescription: 'Super',
      },
      {
        id: 'Administrator',
        description: 'May create other users and grant their roles. Notifications on new services and improvements.',
        sfGuardGroupId: 2,
        sfGuardGroupName: 'admin',
        sfGuardGroupDescription: 'Administrator'
      },
      {
        id: 'Developer',
        description: 'Download libraries, API, other documentation.',
        sfGuardGroupId: 3,
        sfGuardGroupName: 'developer',
        sfGuardGroupDescription: 'Developer'
      },
      {
        id: 'Operations',
        description: 'Sent announcements regarding planned and unplanned outages, upgrades, performance and symbol roll notifications.',
        sfGuardGroupId: 4,
        sfGuardGroupName: 'operations',
        sfGuardGroupDescription: 'Operations'
      },
      {
        id: 'Finance',
        description: 'Sent invoices and billing-related emails.',
        sfGuardGroupId: 5,
        sfGuardGroupName: 'finance',
        sfGuardGroupDescription: 'Finance'
      },
      {
        id: 'DadReporter',
        description: 'The DAD Report reports monthly data access for exchanges that have pass through billing.',
        sfGuardGroupId: 6,
        sfGuardGroupName: 'dad_reporter',
        sfGuardGroupDescription: 'Dad Reporter'
      },
      {
        id: 'MacPermissioner',
        description: 'May access and modify the MAC Address form.',
        sfGuardGroupId: 7,
        sfGuardGroupName: 'mac_permissioner',
        sfGuardGroupDescription: 'MAC Permissioner'
      },
    ];
  }

  parseToArray(groupIds: number[]): number[] {
    return groupIds
      .filter(groupId => !!this.roles.find(role => role.sfGuardGroupId === groupId))
      .sort();
  }

  parseToString(roleGroups: any[]): string {
    const userRoles = [];
    roleGroups.forEach((roleGroup) => {
      if (roleGroup.name === 'super') {
        userRoles.push('Super');
      } else if (roleGroup.name === 'admin') {
        userRoles.push('Administrator');
      } else if (roleGroup.name === 'developer') {
        userRoles.push('Developer');
      } else if (roleGroup.name === 'operations') {
        userRoles.push('Operations');
      } else if (roleGroup.name === 'finance') {
        userRoles.push('Finance');
      } else if (roleGroup.name === 'dad_reporter') {
        userRoles.push('DAD Reporter');
      } else if (roleGroup.name === 'mac_permissioner') {
        userRoles.push('MAC permissioner');
      }
    });
    return userRoles.map(group => group).join(', ');
  }
}
